// extracted by mini-css-extract-plugin
module.exports = {"tip-title":"index_tip-title_12LpR","email-row":"index_email-row_-SG_x","email-input":"index_email-input_2AVN0","tip-content":"index_tip-content_3_rkf"};